// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Q999c","type":"styles_type__2O0yH","choices":"styles_choices__39vgE"};